import React, { FC, useState } from 'react'
import { Typography, Button, Box, makeStyles } from '@material-ui/core'
import { useForm } from 'react-final-form'

import { Drawer } from 'components'

interface ItemProps {
  name: string
  value: string
}

const useStyles = makeStyles({
  box: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingRight: 24,
  },
  button: {
  },
})

export const AsidePreview: FC = () => {
  const classes = useStyles()
  const form = useForm()
  const formState = form.getState().values
  const [open, setOpen] = useState(false)
  const [formData, setFormData] = useState<Array<ItemProps>>([])

  const handleOpen = () => {
    const formData = Object.keys(formState).map((key) => {
      return {
        name: key,
        value: formState[key],
      }
    })

    setFormData(formData)
    setOpen(true)
  }

  return (
    <Box className={classes.box}>
      <Drawer anchor="top" open={open}>
        <Typography variant="h6">Dados Inseridos</Typography>

        {formData.map((item: ItemProps, index: number) => (
          <Typography key={index} variant="body2">
            {item?.name || ''}: {item?.value || ''}
          </Typography>
        ))}
        <Button
          variant="outlined"
          color="primary"
          onClick={() => setOpen(false)}
        >
          Fechar
        </Button>
      </Drawer>

      <Button
        variant="outlined"
        color="primary"
        onClick={() => handleOpen()}
      >
        Abrir Prévia
      </Button>
    </Box>
  )
}
